export { default as SegmentedControl } from './src/SegmentedControl'
